import Asset from 'api/types/models/asset'
import { Badge } from 'components/badge'
import ArrowTopRightIcon from 'components/icons/ArrowTopRightIcon'
import LockIcon from 'components/icons/LockIcon'
import QrIcon from 'components/icons/QrIcon'
import UnlockIcon from 'components/icons/UnlockIcon'
import ToolTip from 'components/tooltip'
import { Link } from 'react-router-dom'

type AssetListCardProps = {
  asset: Asset
}

const AssetListCard = ({
  asset,
}: AssetListCardProps) => {
  return (
    <div className="border-t py-2">

      <div className="flex flex-col gap-1 min-w-0 px-1">

        <div className="flex items-center gap-1.5 min-w-0">
          <ToolTip id={`privacy-indicator-${asset.id}`} content={asset.is_private ? 'Private' : 'Public'}>
            {
              asset.is_private
                ? <LockIcon className='h-4 text-indicator-error' />
                : <UnlockIcon className='h-4 text-primary' />
            }
          </ToolTip>
          <a href={asset.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 min-w-0 hover:underline">
            <span className="font-medium capitalize leading-none truncate">
              {asset.description ?? 'KiCall (Not Named)'}
            </span>
            <ArrowTopRightIcon className="h-3.5 shrink-0 text-gray-400" />
          </a>
        </div>

        <div className="flex items-center gap-2">
          {
            asset.is_activated
              ? (
                <Badge intent="success" className="flex items-center gap-1" size="sm" tooltipId={`mode-${asset.id}`} tooltipContent="Active — scanning opens the KiCall">
                  <QrIcon className="aspect-square h-4" />
                  KiCall · {(asset.total_scans || 0).toString().padStart(2, '0')} scans
                </Badge>
              )
              : (
                <Badge intent="warning" className="flex items-center gap-1" size="sm" tooltipId={`mode-${asset.id}`} tooltipContent="Inactive — scanning redirects to a URL">
                  <ArrowTopRightIcon className="aspect-square h-4" />
                  URL · {(asset.total_url_scans || 0).toString().padStart(2, '0')} scans
                </Badge>
              )
          }
          <code className="text-xs text-gray-400 shrink-0">
            {asset.serial}
          </code>
        </div>

        <div className="flex items-center gap-2 mt-1 text-sm">
          <Link className="url-text" to={`/asset/manage/${asset.masked_uid}/history`}>History</Link>
          <span className="text-gray-300">|</span>
          <Link className="url-text" to={`/asset/manage/${asset.masked_uid}`}>Edit</Link>
        </div>

      </div>

    </div>
  )
}

export default AssetListCard
